import { configureStore } from "@reduxjs/toolkit";
import itemReducer from '../slice/itemSlice.js'

export const store = configureStore({
  reducer: {
    item: itemReducer
  }
})

